import axios, { AxiosRequestConfig } from 'axios';
import { API_HOST_ENV } from '~/src/params';
import type { FormNameDocumentEnum } from '~/src/models/enums/form-name.enum';
import type { FileDataInterface } from '~/src/redux/documents/documents.types';

export interface PostDocumentFileInterface {
    file: File;
    formName: FormNameDocumentEnum;
}

export const postDocumentFile = async (
    data: PostDocumentFileInterface,
    config: AxiosRequestConfig,
    url: string,
) => {
    const formData = new FormData();
    formData.append('file', data?.file);
    formData.append('formName', data?.formName);
    return await axios.post<FileDataInterface>(`${API_HOST_ENV}/${url}`, formData, config);
};
